import { useLocale } from '@lessonup/client-integration';
import { SelectField, SelectFieldProps } from '@lessonup/ui-components';
import { CountryCode } from '@lessonup/utils';
import React, { ForwardedRef, forwardRef } from 'react';
import { countryMapForCountryCode } from './countryMap';

type CountryPickerProps = Omit<SelectFieldProps<CountryCode>, 'options' | 'type'> & {
  label: string;
  ref: ForwardedRef<HTMLSelectElement>;
};

export const CountryPicker = forwardRef<HTMLSelectElement, CountryPickerProps>(({ label, ...otherProps }, ref) => {
  const locale = useLocale();

  const countryMap = countryMapForCountryCode(locale.language);

  const countryOptions = Object.entries(countryMap).map(([k, v]) => {
    return { value: k, label: v };
  });

  return (
    <SelectField size="medium" label={label} defaultValue="nl" {...otherProps} options={countryOptions} ref={ref} />
  );
});

CountryPicker.displayName = 'CountryPicker';
